import React from 'react';
import { 
  Box, 
  Container, 
  Stack, 
  Text, 
  Link, 
  Divider, 
  VStack, 
  HStack, 
  Flex, 
  useColorModeValue,
  Icon
} from '@chakra-ui/react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

// Contract address for the SmartLaw Token
const CONTRACT_ADDRESS = "0x3059B722579949459a7A778771Ec5e2e990392A1";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  const bgColor = useColorModeValue('gray.50', '#060E1C');
  const borderColor = useColorModeValue('gray.200', 'rgba(30, 40, 70, 0.6)');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const headingColor = useColorModeValue('gray.700', 'white');
  const linkHoverColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <Box
      as="footer"
      bg={bgColor}
      color={textColor}
      borderTopWidth="1px"
      borderTopColor={borderColor}
      py={8}
      mt="auto"
    >
      <Container maxW="container.xl">
        <Stack
          direction={{ base: 'column', md: 'row' }}
          spacing={8}
          justify="space-between"
          align={{ base: 'flex-start', md: 'flex-start' }}
        >
          <VStack spacing={3} align="flex-start" maxW={{ base: 'full', md: '300px' }}>
            <Text fontSize="lg" fontWeight="bold" color={headingColor}>
              Judicial Identity Management
            </Text>
            <Text fontSize="sm">
              SmartLaw Token Management for Judicial Participants enabling on-chain verification 
              of credentials and proper access control for legal precedent oracles.
            </Text>
            <Link
              href={`https://polygonscan.com/address/${CONTRACT_ADDRESS}`}
              isExternal
              color={textColor}
              fontSize="xs"
              fontFamily="monospace"
            >
              Contract: {CONTRACT_ADDRESS.slice(0, 6)}...{CONTRACT_ADDRESS.slice(-4)}
            </Link>
          </VStack>

          <Stack direction={{ base: 'column', md: 'row' }} spacing={{ base: 6, md: 8 }}>
            <VStack align="flex-start" minW="120px">
              <Text fontSize="md" fontWeight="bold" color={headingColor}>
                Platform
              </Text>
              <Link href="/" color={textColor} _hover={{ color: linkHoverColor }}>
                Home
              </Link>
              <Link href="/create" color={textColor} _hover={{ color: linkHoverColor }}>
                Create Token
              </Link>
              <Link href="/mint" color={textColor} _hover={{ color: linkHoverColor }}>
                Mint Token
              </Link>
              <Link href="/configure" color={textColor} _hover={{ color: linkHoverColor }}>
                Configure
              </Link>
            </VStack>
            
            <VStack align="flex-start" minW="120px">
              <Text fontSize="md" fontWeight="bold" color={headingColor}>
                Ecosystem
              </Text>
              <Link href="https://evidencer.io" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                Evidencer
              </Link>
              <Link href="https://oracle.evidencer.io" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                Legal Oracle
              </Link>
              <Link href="https://forms.evidencer.io" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                Legal Forms
              </Link>
              <Link href="https://tokens.evidencer.io" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                SmartLaw Tokens
              </Link>
            </VStack>
            
            <VStack align="flex-start" minW="120px">
              <Text fontSize="md" fontWeight="bold" color={headingColor}>
                Resources
              </Text>
              <Link href="/about" color={textColor} _hover={{ color: linkHoverColor }}>
                About
              </Link>
              <Link href="https://freeweb3.com" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                FreeWeb3
              </Link>
              <Link href="https://nav.evidencer.io" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                Ecosystem
              </Link>
              <Link href="https://github.com/lexautomatico" isExternal color={textColor} _hover={{ color: linkHoverColor }}>
                GitHub
              </Link>
            </VStack>
          </Stack>
        </Stack>

        <Divider my={6} borderColor={borderColor} />

        <Flex
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ base: 'flex-start', md: 'center' }}
          gap={3}
        >
          <Text fontSize="sm">
            © {currentYear} SmartLaw Judicial Identity Management. All rights reserved.
          </Text>
          
          <HStack spacing={4}>
            <Link href="https://github.com/lexautomatico" isExternal aria-label="GitHub">
              <Icon as={FaGithub} boxSize={4} />
            </Link>
            <Link href="https://x.com/tenfinney" isExternal aria-label="Twitter">
              <Icon as={FaXTwitter} boxSize={4} />
            </Link>
            <Link href="https://www.linkedin.com/in/scott-stevenson-jd/" isExternal aria-label="LinkedIn">
              <Icon as={FaLinkedin} boxSize={4} />
            </Link>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;